export const getUrl = (modalType: string, type: any) => {
  const list = modalType.split('-');
  if (list.length >= 2) {
    return '/' + list[0] + '/' + type[0] + list[1] + type[1];
  } else {
    console.error(`modalType:${modalType}结构错误`);
  }
};
export const getApiPermission = (modalType: string, type: any) => {
  const list = modalType.split('-');
  if (list.length >= 2) {
    const model_and_suffix = modalType.replace(/^[^-]*-/, '');
    return list[0] + '/' + type + model_and_suffix;
  } else {
    console.error(`modalType:${modalType}结构错误`);
  }
};
